import React from 'react'
import logo from '@images/SVG/logo'
import closeICO from '@images/SVG/x'
import useModal from '@/hooks/useModal'
import { NavLink } from 'react-router-dom'
import style from './style_m.module.scss'

export default () => {
  const { changeSettings } = useModal()
  const onCloseHandler = () => {
    changeSettings(false)
  }
  return (
    <div className={style.modalContainer}>
      <header className={style.modalHead}>
        <div className={style.logoContainer}>
          <img src={logo} alt="logo" />
          <span onClick={onCloseHandler}>
            <img src={closeICO} alt="close" />
          </span>
        </div>
      </header>
      <main className={style.modalBody}>
        <h1>Будь-ласка підтвердіть ваш аккаунт</h1>
        <p>
          Будь-ласка підтвердіть ваш аккаунт через посилання на вашій пошті.
        </p>
        <p>
          Якщо ви не отримали листа, будь-ласка перевірте в спамі або напишіть нам
        </p>
        <h2>messenger link</h2>
        <NavLink to="/" onClick={onCloseHandler}>На головну</NavLink>
      </main>
    </div>
  )
}